import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ModalBody, ModalFooter } from 'reactstrap'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

const EditVideo = (props) => {
  const video = props.content.find((item) =>
    item.id === parseInt(props.match.params.id) ? item : null
  )
  let language = props.language || {}

  return (
    <>
      <ModalBody>
        <div className='row'>
          <div className='col-md-4 title-container'>
            <div className='upload-video-form-row'>
              <label>
                {language.settings ? language.settings.title : null}:{' '}
              </label>
              <input
                type='text'
                name='title'
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>
        </div>

        <div className='custom-control custom-checkbox-info mt-2'>
          <input
            className='custom-control-input'
            id='required_content'
            type='checkbox'
            checked={video ? video.required : false}
            onChange={() => props.setContentRequired(video.id)}
          />
          <label
            className='custom-control-label '
            htmlFor='required_content'
            style={{ fontSize: '14px', paddingTop: '2px' }}
          >
            {language?.courses?.required}
          </label>
        </div>
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start mt-3'>
        <Link to={`/course/${props.id}/edit`}>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.updateVideoContent(video.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(video.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </>
  )
}

export default function ManageVideos(props) {
  useEffect(() => {
    props.fetchTextContent(props.match.params.id)
  }, [])

  return (
    <CustomModal courseId={props.course_id} title='Edit Video' size='lg'>
      <EditVideo {...props} />
    </CustomModal>
  )
}
